export const STRIPE_PAYMENT_TYPES = {
  CARD: 'card',
  SEPA_DEBIT: 'sepaDebit',
  IDEAL: 'ideal',
  BANCONTACT: 'bancontact',
};

export const STRIPE_REDIRECT_STATUS = {
  ERROR: 'failed',
  SUCCESS: 'succeeded',
};

export const STRIPE_BANK_REDIRECT_PAYMENT_METHODS = {
  IDEAL: STRIPE_PAYMENT_TYPES.IDEAL,
  BANCONTACT: STRIPE_PAYMENT_TYPES.BANCONTACT,
};
